import { IApiInstance, IRequestParameters, IResponse, IUrlParams } from '@dash/apiInstance';
import { apiRequest, defaultApiVersionPath, getRequestHeaders, getRequestUrl } from './apiHelpers';

class ApiInstance implements IApiInstance {
  pathTemplate: string;

  versionPath: string;

  type: 'base' | 'UnifiedLogin';

  constructor(
    pathTemplate: string,
    versionPath: string = defaultApiVersionPath,
    type: 'base' | 'UnifiedLogin' = 'base',
  ) {
    this.pathTemplate = pathTemplate;
    this.versionPath = versionPath;
    this.type = type || 'base';
  }

  get = <T extends IResponse<T>>({
    search,
    pathParams,
    contentTypeHeader,
    acceptHeader,
    optionalHeader,
    type = this.type,
  }: IUrlParams) => {
    return apiRequest<T>({
      method: 'GET',
      data: {},
      headers: getRequestHeaders(contentTypeHeader, acceptHeader, optionalHeader, type),
      url: getRequestUrl(search, this.pathTemplate, this.versionPath, pathParams, type),
    });
  };

  put = <T extends IResponse<T>>({
    data,
    search,
    pathParams,
    contentTypeHeader,
    acceptHeader,
    optionalHeader,
    type = this.type,
  }: IRequestParameters) => {
    return apiRequest<T>({
      method: 'PUT',
      headers: getRequestHeaders(contentTypeHeader, acceptHeader, optionalHeader, type),
      data: data || {},
      url: getRequestUrl(search, this.pathTemplate, this.versionPath, pathParams, type),
    });
  };

  post = <T extends IResponse<T>>({
    data,
    pathParams,
    search,
    acceptHeader,
    contentTypeHeader,
    optionalHeader,
    type = this.type,
  }: IRequestParameters) => {
    return apiRequest<T>({
      method: 'POST',
      headers: getRequestHeaders(contentTypeHeader, acceptHeader, optionalHeader, type),
      data: data || {},
      url: getRequestUrl(search, this.pathTemplate, this.versionPath, pathParams, type),
    });
  };

  delete = <T extends IResponse<T>>({ data, pathParams, search, type = this.type }: IRequestParameters) => {
    const headers = getRequestHeaders(undefined, undefined, undefined, type);

    delete headers['Content-Type'];

    return apiRequest<T>({
      method: 'DELETE',
      headers,
      data: data || {},
      url: getRequestUrl(search, this.pathTemplate, this.versionPath, pathParams, type),
    });
  };
}

export default ApiInstance;
